import { forwardRef, type ComponentPropsWithoutRef } from 'react';

type Props = {
  symbol: string;
} & ComponentPropsWithoutRef<'svg'>;

export const SvgSymbol = forwardRef<SVGSVGElement, Props>(
  ({ symbol, ...props }, ref) => (
    <svg fill="currentColor" ref={ref} {...props}>
      <use xlinkHref={`/assets/images/symbol-defs.svg#${symbol}`} />
    </svg>
  ),
);

SvgSymbol.displayName = 'SvgSymbol';
